import { API } from '@Providers';

interface EditAnimalFeePayload {
  animal_id: string;
  new_fee: number;
  discount_type?: 'percent' | 'fixed';
  discount?: number;
}

export default async function editAnimalFee(payload: EditAnimalFeePayload) {
  const endpoint = '/api/shelter/cart/edit-animal-fee/';
  return API({ endpoint, method: 'put', payload });
}
